export const DOWNLOAD_TOAST_IDS = {
    FAILED: 'failed-download',
    FINISHED: 'successful-download-finish',
    STARTED: 'successful-download-start',
};
